// stores/referralStore.js

import { defineStore } from 'pinia';

const COOKIE_NAME = 'referral_partner_tracking_code';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365 * 3; // 3 years in seconds

export const useReferralStore = defineStore('referral', {
  state: () => ({
    partnerCode: null,
  }),
  actions: {
    setPartnerCode(code) {
      if (!code) return;

      this.partnerCode = code;

      // Store in cookie with 3-year expiry
      const cookie = useCookie(COOKIE_NAME, {
        maxAge: COOKIE_MAX_AGE,
        path: '/',
        sameSite: 'lax',
      });
      cookie.value = code;
    },
    getPartnerCode() {
      // First check cookie (new way)
      const cookie = useCookie(COOKIE_NAME);
      if (cookie.value) {
        this.partnerCode = cookie.value;
        return cookie.value;
      }

      // Fallback to localStorage (old way) for backwards compatibility
      if (process.client && localStorage) {
        const storedCode = localStorage.getItem(COOKIE_NAME);
        if (storedCode) {
          // Migrate to cookie
          this.setPartnerCode(storedCode);
          // Clean up localStorage
          localStorage.removeItem(COOKIE_NAME);
          return storedCode;
        }
      }

      return this.partnerCode;
    },
    clearPartnerCode() {
      this.partnerCode = null;
      const cookie = useCookie(COOKIE_NAME);
      cookie.value = null;
    },
    getUtmParams() {
      const code = this.getPartnerCode();
      if (code) {
        return {
          utm_medium: 'partner_iframe',
          utm_source: code
        };
      }
      return {};
    },
  },
});
